import { IconButton, Stack } from '@mui/material';
import { DeleteFilled, DownloadOutlined } from '@ant-design/icons';
import { GenericTableDataFileDto } from 'inside-fifa/api/generic-tables/dto';

type ActionsColumnFileProps = {
    row: GenericTableDataFileDto;
    onDelete: () => void;
    onDownload: () => void;
};

export const ActionsColumnFile = ({ row, onDelete, onDownload }: ActionsColumnFileProps) => {
    return (
        <Stack direction="row">
            <IconButton onClick={onDelete}>
                <DeleteFilled />
            </IconButton>
            {row.azureBlobPath !== null && row.azureBlobPath !== undefined && row.azureBlobPath.trim() !== '' && (
                <IconButton onClick={onDownload}>
                    <DownloadOutlined />
                </IconButton>
            )}
        </Stack>
    );
};
